import { createFileRoute } from "@tanstack/react-router";
import ExemptsConfigurations from "@/components/invoices/configuration/exempts/exempts-configuration";
import InvoicesConfigurationNavigation from "@/components/invoices/configuration/invoices-configuration-navigation";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";

export const Route = createFileRoute(
  "/_authenticated/settings/_layout/invoices/exempts",
)({
  component: ExemptsPage,
});

function ExemptsPage() {
  return (
    <RouteGuardPermissions
      permissions={[
        { module: "invoices_exempts_documents", actions: ["read", "update"] },
      ]}
    >
      <div className="gap-4 flex-col flex m-0 p-0">
        <InvoicesConfigurationNavigation />
        <ExemptsConfigurations module="invoices_configuration_exempts" />
      </div>
    </RouteGuardPermissions>
  );
}
